import axios from "axios";

export default {
  getEan(ean, energy=null) {
    if (!ean) {
      return Promise.reject(new Error("EAN is required"));
    }
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.GRD_SERVICE_PUBLIC_PATH}/ean/${ean}/check`,
        params: { energy: energy }
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getMeter(meter) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.GRD_SERVICE_PUBLIC_PATH}/meter/${meter}`,
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
};



// WEBPACK FOOTER //
// ./src/services/grdService.js